<template>
  <a-spin :spinning="formOption.busy">
    <a-form-item label="菜单类型" :label-col="{ span: 6 }"
                 :wrapper-col="{ span: 12 }">
      <a-radio-group v-model="type">
        <a-radio :value="0">目录</a-radio>
        <a-radio :value="1">菜单</a-radio>
        <a-radio :value="2">按钮</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 12 }"
    >
      <a-form-item label="名称">
        <a-input v-decorator="['name', rules.name]"/>
      </a-form-item>
      <a-form-item label="是否使用">
        <a-switch
            v-decorator="['isUse',{ valuePropName: 'checked' }]"
            checked-children="是"
            un-checked-children="否"/>
      </a-form-item>
      <a-form-item label="业务编号" v-if="type===1">
        <a-input v-decorator="['bussinessNo']" :maxLength="30"/>
      </a-form-item>
<!--      <a-form-item label="所属业务" v-if="type===1">-->
<!--        <a-select-->
<!--            v-decorator="['bussinessMs']"-->
<!--            :options="bussTypeArr"-->
<!--        ></a-select>-->
<!--      </a-form-item>-->
      <a-form-item label="上级菜单" v-if="type===1||type===2">
        <a-tree-select
            v-decorator="['parentId']"
            allow-clear
            :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
            :treeData="treeData"
            :replaceFields="{children:'children', title:'name', key:'menuId', value: 'menuId' }"
        >
        </a-tree-select>

      </a-form-item>
      <a-form-item label="菜单URL" v-if="type===1">
        <a-input v-decorator="['url',rules.url]"/>
      </a-form-item>
      <a-form-item label="授权标识" v-if="type===1||type===2">
        <a-input v-decorator="['perms']"/>
      </a-form-item>

      <a-form-item label="排序号" v-if="type===0||type===1">
        <a-input v-decorator="['orderNum']"/>
      </a-form-item>
      <a-form-item label="图标" v-if="type===0||type===1">
        <a-input v-decorator="['icon']"/>
        <!--                <uploader :num="1" v-decorator="['icon']"></uploader>-->
      </a-form-item>

    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>


  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import XEUtils from "xe-utils";
import {formatter as fmt} from "@/utils/form-formatter";
//菜单api
import {dataApi} from '@/services/comm/menuManage';
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.info(loadBaseCodeData, XEUtils)


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    name: {
      rules: [{required: true, message: "请输入名称"}]
    },
    url: {
      rules: [{required: true, message: "请输入菜单URL"}]
    },
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  this.createUserId = entity.createUserId;
  this.createDate = entity.createDate;
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  this.type = 0;
  return {
    isUse: true
  };
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.type = entity.data.type || 0;
  return fmt.formatFormLoad(entity, [], ['isUse']);
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  let menuData = await dataApi.getMenuList();
  this.treeData = XEUtils.toArrayTree(menuData.data, {
    key: 'menuId',
    parentKey: 'parentId',
    children: 'children'
  });
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  entities.parentId = entities.parentId || 0;
  entities.menuId = vm.keyId;
  entities.type = vm.type;

  entities.createUserId = vm.createUserId;
  entities.createDate = vm.createDate;
  entities.isShop = 0;
  console.log(entities)
  // 调用dataApi的saveFormDetail方法异步保存菜单数据，并返回结果

  return await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  watch: {},
  components: {},
  data() {
    return {
      type: 0,
      bussTypeArr: [],
      treeData: []
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
  },
};
</script>

<style scoped lang="stylus">

</style>